/* eslint-disable react/prop-types */
//import React from 'react';
import React, { useState, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import NovoBanner from './novobanner';
import BannerLista from './bannerlista';
import BannerEdit from './banneredit';

import AuthUser from '../../components/AuthUser';


const BannerIndex = ({ match }) => {

     // eslint-disable-next-line no-unused-vars
     const { verificarPermissao } = AuthUser();
     // eslint-disable-next-line no-unused-vars
     const [permissaoVer, setPermissaoVer] = useState(false);
     const [permissaoAdicionar, setPermissaoAdicionar] = useState(false);
     const [permissaoAtualizar, setPermissaoAtualizar] = useState(false);
     const [permissaoAtivar, setPermissaoAtivar] = useState(false);
     const [permissaoRemover, setPermissaoRemover] = useState(false);
 
     useEffect(() => {
 
         setPermissaoVer(verificarPermissao('SALA','ver'));
         setPermissaoAdicionar(verificarPermissao('SALA','adicionar'));
         setPermissaoAtualizar(verificarPermissao('SALA','atualizar'));
         setPermissaoAtivar(verificarPermissao('SALA','ativar'));
         setPermissaoRemover(verificarPermissao('SALA','remover'));
 
     },);
 
     return (
    <Switch>

        <Redirect exact from={`${match.url}/`}  render={(props) => <NovoBanner {...props} permissaoAdicionar={permissaoAdicionar} />} />

        <Route path={`${match.url}/novobanner`} render={(props) => <NovoBanner {...props} permissaoAdicionar={permissaoAdicionar} />} />

        <Route path={`${match.url}/bannerLista`}  render={(props) => <BannerLista {...props} permissaoVer={permissaoVer} permissaoAtivar={permissaoAtivar} permissaoRemover={permissaoRemover} />} />

        <Route path={`${match.url}/banneredit/:id`} render={(props) => <BannerEdit {...props} permissaoAtualizar={permissaoAtualizar} permissaoAtivar={permissaoAtivar} />} />

    </Switch>)
}

export default BannerIndex